import React, { useEffect, useState } from 'react'
import parse from 'url-parse'
import StickyBox from 'react-sticky-box'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import AddToCartForm from './addToCartForm'
import ProductImages from './productImages'

const ProductMainContent = ({ client }) => {
  const [productData, setProductData] = useState()
  const [selectedVariant, setSelectedVariant] = useState()
  const [instructions, setInstructions] = useState()

  const fetchMetaFields = async (productHandle) => {
    const query = `query {
      productByHandle(handle: "${productHandle}") {
        metafields(first: 20, namespace: "accentuate") {
          edges {
            node {
              key
              value
            }
          }
        }
      }
    }`

    const optionsQuery1 = {
      method: 'post',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': '83ce7d1f48fea93063d90fa10a8aa250',
      },
      body: query,
    }

    const res = await fetch(
      'https://heartonco.myshopify.com/api/graphql',
      optionsQuery1
    )
    const response = await res.json()

    if (response.data.productByHandle) {
      const edges = response.data.productByHandle.metafields.edges
      let sortedEdges = []
      edges.map((edge) => {
        if (edge.node.key === 'details') {
          sortedEdges = [edge, ...sortedEdges]
        } else {
          sortedEdges = [...sortedEdges, edge]
        }
      })

      setInstructions(sortedEdges)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)

    const urlParsed = parse(window.location.href)
    const productHandle = urlParsed.pathname.substr(
      urlParsed.pathname.lastIndexOf('/') + 1
    )

    fetchMetaFields(productHandle)

    const getProductInfo = async () => {
      const resProduct = await fetch(`/products/${productHandle}.js`, {
        headers: {
          'Content-Type': 'application/json',
          pragma: 'no-cache',
          'cache-control': 'no-cache',
        },
        credentials: 'same-origin',
      })
      const data = await resProduct.json()
      setProductData(data)
    }

    getProductInfo()
  }, [])

  const onChangeVariant = (variant) => {
    setSelectedVariant(variant)
  }

  return (
    <div>
      {productData ? (
        <div className='container'>
          <div className='content'>
            <ProductImages
              selectedVariant={selectedVariant}
              productData={productData}
            />

            <div className='product-info-wrapper'>
              <StickyBox offsetTop={150}>
                <h1>{productData.title}</h1>

                <AddToCartForm
                  productData={productData}
                  onChangeVariant={onChangeVariant}
                />

                <div
                  dangerouslySetInnerHTML={{
                    __html: productData.description,
                  }}
                  className='product-description'
                ></div>

                <Tabs>
                  <TabList>
                    {instructions &&
                      instructions.map((edge, i) => (
                        <Tab key={i}>{edge.node.key.replace('_', ' ')}</Tab>
                      ))}
                  </TabList>

                  {instructions &&
                    instructions.map((edge, i) => (
                      <TabPanel key={i}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: JSON.parse(edge.node.value).html,
                          }}
                          className='product-description'
                        ></div>
                      </TabPanel>
                    ))}
                </Tabs>
              </StickyBox>
            </div>
          </div>
        </div>
      ) : (
        <div className='container'>
          <div className='hide-mobile'>
            <div className='content ssc'>
              <div className='product-images-wrapper'>
                <div className='product-thumbnails'>
                  <div className='ssc-square mb'></div>
                  <div className='ssc-square'></div>
                </div>
                <div className='product-images'>
                  <div className='ssc-square mb'></div>
                  <div className='ssc-square'></div>
                </div>
              </div>
              <div className='product-info-wrapper'>
                <div className='w-100'>
                  <div className='ssc-head-line mb'></div>
                  <div className='ssc-head-line mb'></div>
                  <div className='ssc-head-line mb'></div>
                  <div className='ssc-line w-100 mb'></div>
                  <div className='ssc-line w-70 mb'></div>
                  <div className='ssc-line w-30 mb'></div>
                  <div className='ssc-line w-80 mb'></div>
                  <div className='ssc-line w-60 mb'></div>
                  <div className='ssc-line w-100 mb'></div>
                  <div className='ssc-line w-70 mb'></div>
                  <div className='ssc-line w-30 mb'></div>
                  <div className='ssc-line w-80 mb'></div>
                  <div className='ssc-line w-60 mb'></div>
                </div>
              </div>
            </div>
          </div>
          <div className='show-mobile'>
            <div className='content ssc'>
              <div className='product-info-wrapper'>
                <div className='w-100'>
                  <div className='ssc-head-line mb'></div>
                  <div className='ssc-head-line mb'></div>
                  <div className='ssc-head-line mb'></div>
                  <div className='ssc-line w-100 mb'></div>
                  <div className='ssc-line w-70 mb'></div>
                  <div className='ssc-line w-30 mb'></div>
                  <div className='ssc-line w-80 mb'></div>
                  <div className='ssc-line w-60 mb'></div>
                  <div className='ssc-line w-100 mb'></div>
                  <div className='ssc-line w-70 mb'></div>
                  <div className='ssc-line w-30 mb'></div>
                  <div className='ssc-line w-80 mb'></div>
                  <div className='ssc-line w-60 mb'></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ProductMainContent
